"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PageContent_1 = require("./PageContent");
exports.default = PageContent_1.default;
//# sourceMappingURL=index.js.map